
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

const columns = [

  { field: "shop", label: "ALLOCATION HEAD", align: "left" },
  
  { field: "dl", label: "DIRECT LABOUR", align: "right" },
  { field: "ds", label: "DIRECT STORE", align: "right" },
  { field: "ocl", label: "ON COST LABOUR", align: "right" },
  { field: "ocs", label: "ON COST STORE", align: "right" },
  { field: "total", label: "Total", align: "right" },
 



];

export default function WGRTable({ rows }) {
  return (
    <TableContainer>
      <Table
        size="small"
        stickyHeader
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.field}
                align={column.align}
                sx={{
                  fontWeight: 700,
                  bgcolor: "grey.200",
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, index) => {

            const total =
              Number(row["DIRECT LABOUR"] || 0) +
              Number(row["DIRECT STORE"] || 0) +
              Number(row["ON COST LABOUR"] || 0) +
              Number(row["ON COST STORE"] || 0) ;
              

           


            // console.log(totalLabour);

            return (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:nth-of-type(even)": {
                    bgcolor: "grey.50",
                  },
                }}
              >

                <TableCell align="left" sx={{ paddingLeft: "100px" }}>
                  {row.Allocation}
                </TableCell>

               
                <TableCell align="right">
                  <CurrencyCell
                    value={row["DIRECT LABOUR"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={row["DIRECT STORE"]}
                  />
                </TableCell>

               
                <TableCell align="right">
                  <CurrencyCell
                    value={row["ON COST LABOUR"]}
                  />
                </TableCell>

                <TableCell align="right">
                  <CurrencyCell
                    value={row["ON COST STORE"]}
                  />
                </TableCell>

                  <TableCell align="right">
                  <CurrencyCell
                    value={total}
                  />
                </TableCell>




              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

